// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PtoArrDownloadOutlinedSvg from "@fishx/icons-svg/es/asn/PtoArrDownloadOutlined";
import FishxIcon from '../components/FishxIcon';

var PtoArrDownloadOutlined = function PtoArrDownloadOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PtoArrDownloadOutlinedSvg
  }));
};

PtoArrDownloadOutlined.displayName = 'PtoArrDownloadOutlined';
export default React.forwardRef(PtoArrDownloadOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PtoArrDownloadOutlined.js
// module id = 3872
// module chunks = 0